<form [formGroup]="form" (ngSubmit)="onSubmit()" class="card integration-settings-form">
  <div class="card-body">
    <div class="mb-3">
      <label for="apiBaseUrl" class="form-label">
        {{ 'Settings::ConversationalAnalyticsApiBaseUrl' | abpLocalization }}
      </label>
      <input
        id="apiBaseUrl"
        type="text"
        class="form-control"
        formControlName="apiBaseUrl"
        [class.is-invalid]="isControlInvalid('apiBaseUrl')" />
      <div class="invalid-feedback" *ngIf="hasError('apiBaseUrl', 'required')">
        {{ 'Settings::ConversationalAnalyticsApiBaseUrl' | abpLocalization }}
        {{ '::Required' | abpLocalization }}
      </div>
      <div class="invalid-feedback" *ngIf="hasError('apiBaseUrl', 'pattern')">
        {{ getUrlInvalidMessage() }}
      </div>
      <small class="form-text text-muted" *ngIf="!hasError('apiBaseUrl', 'required')">
        {{ 'Settings::ConversationalAnalyticsApiBaseUrlDescription' | abpLocalization }}
      </small>
    </div>

    <div class="mb-3">
      <label for="identityBaseUrl" class="form-label">
        {{ 'Settings::ConversationalAnalyticsIdentityBaseUrl' | abpLocalization }}
      </label>
      <input
        id="identityBaseUrl"
        type="text"
        class="form-control"
        formControlName="identityBaseUrl"
        [class.is-invalid]="isControlInvalid('identityBaseUrl')" />
      <div class="invalid-feedback" *ngIf="hasError('identityBaseUrl', 'required')">
        {{ 'Settings::ConversationalAnalyticsIdentityBaseUrl' | abpLocalization }}
        {{ '::Required' | abpLocalization }}
      </div>
      <div class="invalid-feedback" *ngIf="hasError('identityBaseUrl', 'pattern')">
        {{ getUrlInvalidMessage() }}
      </div>
      <small class="form-text text-muted" *ngIf="!hasError('identityBaseUrl', 'required')">
        {{ 'Settings::ConversationalAnalyticsIdentityBaseUrlDescription' | abpLocalization }}
      </small>
    </div>

    <div class="mb-3">
      <label for="scope" class="form-label">
        {{ 'Settings::ConversationalAnalyticsScope' | abpLocalization }}
      </label>
      <input
        id="scope"
        type="text"
        class="form-control"
        formControlName="scope"
        [class.is-invalid]="isControlInvalid('scope')" />
      <div class="invalid-feedback" *ngIf="hasError('scope', 'required')">
        {{ 'Settings::ConversationalAnalyticsScope' | abpLocalization }}
        {{ '::Required' | abpLocalization }}
      </div>
      <small class="form-text text-muted" *ngIf="!hasError('scope', 'required')">
        {{ 'Settings::ConversationalAnalyticsScopeDescription' | abpLocalization }}
      </small>
    </div>

    <div class="mb-3">
      <label for="clientId" class="form-label">
        {{ 'Settings::ConversationalAnalyticsClientId' | abpLocalization }}
      </label>
      <input
        id="clientId"
        type="text"
        class="form-control"
        formControlName="clientId"
        [class.is-invalid]="isControlInvalid('clientId')" />
      <small class="form-text text-muted" *ngIf="!hasError('clientId', 'required')">
        {{ 'Settings::ConversationalAnalyticsClientIdDescription' | abpLocalization }}
      </small>
    </div>

    <div class="mb-3">
      <label for="clientSecret" class="form-label">
        {{ 'Settings::ConversationalAnalyticsClientSecret' | abpLocalization }}
      </label>
      <input
        id="clientSecret"
        type="password"
        class="form-control"
        formControlName="clientSecret"
        [placeholder]="'Settings::MaskedAreaPlaceholder' | abpLocalization"
        [class.is-invalid]="isControlInvalid('clientSecret')" />
      <small class="form-text text-muted" *ngIf="!hasError('clientSecret', 'required')">
        {{ 'Settings::ConversationalAnalyticsClientSecretDescription' | abpLocalization }}
      </small>
    </div>

  </div>

  <div class="integration-settings-form__footer">
    <cx-form-actions
      layout="inline"
      [showCancel]="false"
      [saveLabel]="isSubmitting ? ('::Saving' | abpLocalization) : ('::Save' | abpLocalization)"
      [disabled]="isSubmitting || form.disabled || hasActiveSync"
      [isSubmitting]="isSubmitting">
      <button
        formActionsExtra
        type="button"
        class="btn btn-secondary form-actions__btn"
        [disabled]="isTesting || form.disabled"
        (click)="testConnection()">
        <span
          *ngIf="isTesting"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"></span>
        {{ isTesting ? ('::Testing' | abpLocalization) : ('::TestConnection' | abpLocalization) }}
      </button>
    </cx-form-actions>
  </div>
</form>
